export default {
  aboutMe: 'About Me',
  aboutHer: 'About Her',
  aboutHim: 'About Him',
  moments: 'Moments',
  interests: 'Interests',
  languages: 'Languages',
  storyAlbum: 'Story Album',
  noMoments: 'No moments yet',
  videoCall: 'Video Call',
  follow: 'Follow',
  unfollow: 'Unfollow',
  report: 'Report',
  block: 'Block',
  unblock: 'Unblock',
  unblockSuccess: 'Removed from blacklist successfully',
  blockTips: 'Are you sure you want to block this user? You will not receive any messages from this user after blocking.',
}
